// extracted by mini-css-extract-plugin
export default {"animationduration":".4s","footerheight":"64px","footerpaddingbottom":"16px","ngrMenySupport02Base":"#b6ada5","ngrMenyPrimaryBase":"#c8102e"};